import { useContext, useEffect, useState } from 'react';
import Nav from '../../components/breadcrumb';
import PageHeader, { Title } from '../../components/pageheader';
import { HTMLEditor } from '../../components/tinymce';
import { EmailWrapperBottom, EmailWrapperTop, StatementEmailTemplate } from '../../assets/emails';
import { AppUserContext } from '../../App';
import { PageLoading } from '../../components/loading';
import cur from '../../components/currency';
import SelectizeInput from '../../components/selectize';
import { Form, InputGroup } from 'react-bootstrap';
import { errorAlert, infoAlert, successAlert } from '../../components/toastr';
import { SubmitButton } from '../../components/btns';
import { useNavigate } from 'react-router-dom';
import { sendStatementEmail } from '../../resources/api/clients';



/**
 * 
 * @param {Object} props
 * @param {import('../../resources/api/clients').ClientObject} props.details 
 * @returns 
 */
const SendStatement = ({ details, data, balance, printAll }) => {

    const nav_items = [
        { title: 'Clients', href: "/app/clients" },
        { title: details.title, href: `/app/clients/${details.id}` },
        { title: 'Generate Statement', href: `/app/clients/${details.id}/generate-statement` },
        { title: 'Send Email' }
    ]



    const { profile } = useContext(AppUserContext);
    const navigate = useNavigate();
    const [isLoaded, setLoaded] = useState(false);

    const [isSubmitting, setSubmitting] = useState(false);
    const [subject, setSubject] = useState(`Statement of Accounts - Legacy Productions`);
    const [emails, setEmails] = useState([]);
    const [client_contacts, setClientContacts] = useState([]);
    const [ccs, setCCs] = useState([`created_${profile.email}`]);
    const [other_contacts, setOtherContacts] = useState([]);
    const [html, setHTML] = useState(StatementEmailTemplate);


    useEffect(() =>
        setOtherContacts([{ title: profile.email, id: `created_${profile.email}` }]),
        [profile.email]
    );



    useEffect(() => {


        const con_replacements = {
            display_name: "[Your Name]",
            job_title: "[Your Position]",
        }
        setLoaded(false);

        let _html = StatementEmailTemplate;

        _html = _html.replace("[Client Name]", details.title);
        _html = _html.replace("[Balance]", cur(balance, 0).format())


        Object.keys(con_replacements).forEach(e => {
            _html = _html.replace(con_replacements[e], profile[e] || con_replacements[e])
        });

        setHTML(_html);

        setClientContacts(details.contact_persons
            .filter(c => !!c.email)
            .map(c => ({ title: c.display_name, id: c.id, email: c.email })
            )
        );


        setLoaded(true);


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [details.id, profile.id])

    const submitEmail = () => {

        let _ids = emails.filter(e => !e.startsWith("created_")),
            _emails = client_contacts.filter(c => (_ids.indexOf(c.id) !== -1)).map(c => c.email),
            _created_emails = emails.filter(e => e.startsWith("created_")).map(e => e.replace("created_", ""));

        let _ccs = ccs.filter(e => e.startsWith("created_")).map(e => e.replace("created_", ""));

        const _data = {
            to: [..._emails, ..._created_emails],
            cc: _ccs,
            html: `${EmailWrapperTop}${html}${EmailWrapperBottom}`,
            subject,
            comments: data,
            printAll: printAll ? 1 : 0
        }

        setSubmitting(true);
        infoAlert("Sending email...");
        sendStatementEmail(_data, details.id)
            .then(({ message }) => {
                successAlert(message);
                navigate(`/app/clients/${details.id}`);
            })
            .catch(e => {
                setSubmitting(false);
                errorAlert(e);
            })


    }

    if (!isLoaded) return <PageLoading />;

    return (
        <>
            <Nav items={nav_items} />

            <PageHeader maxWidth="900">
                <Title>
                    Send Statement of Accounts
                </Title>
            </PageHeader>

            <div className="max-800 p-1">
                {/* <Form.Label className='h5'>To:</Form.Label> */}
                <InputGroup className='my-1 my-sm-2'>
                    <InputGroup.Text className='border-0 bg-white'>To</InputGroup.Text>
                    <SelectizeInput
                        placeholder='Select Emails or create'
                        items={emails}
                        options={client_contacts}
                        onChange={val => setEmails(val.split(","))}
                        addOption={option => setClientContacts(c => c.concat(option))}
                        maxItems={5}
                        create
                    />
                </InputGroup>
                <InputGroup className='my-1 my-sm-2'>
                    <InputGroup.Text className='border-0 bg-white'>CC</InputGroup.Text>
                    <SelectizeInput
                        placeholder='Select Emails or create'
                        items={ccs}
                        options={other_contacts}
                        onChange={val => setCCs(val.split(","))}
                        addOption={option => setOtherContacts(c => c.concat(option))}
                        maxItems={5}
                        create
                    />
                </InputGroup>
                <InputGroup className='my-1 my-sm-2'>
                    <InputGroup.Text className='border-0 bg-white'>Subject</InputGroup.Text>
                    <Form.Control size="sm" className='border-0 bg-white' value={subject} onChange={e => setSubject(e.currentTarget.value)} />
                </InputGroup>

                <hr />
                {/* <Form.Label className='h5'>Email:</Form.Label> */}
                <HTMLEditor
                    value={html}
                    onChange={t => setHTML(t)}
                />

                <hr />

                <SubmitButton isSubmitting={isSubmitting} onClick={submitEmail}>
                    Send Email
                </SubmitButton>

            </div>
        </>
    )


}

export default SendStatement;